import React from "react";
import { Routes, Route } from "react-router-dom";
import { NewAssistance } from "../pages/assistance";
import { AssistanceLayout } from "../layouts/AssistanceLayout";

export function AssistanceRouter() {
  return (
    <Routes>
      <Route path="/" element={<AssistanceLayout />}>
        {/* Ruta con parámetro dinámico :assistantId */}
        <Route path=":assistantId" element={<NewAssistance />} />
      </Route>
    </Routes>
  );
}
